export default "__VITE_ASSET__BbkPvdoB__"